import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { MatList, MatListItem } from '@angular/material/list';
import { TranslatePipe } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable, Subscription } from 'rxjs';
import { ComponentService } from 'src/app/service/component.service';
import { DiscountsService } from 'src/app/service/myaccount/discounts.service';

@Component({
  selector: 'app-discount-type-details',
  templateUrl: './discount-type-details.component.html',
  styleUrls: ['./discount-type-details.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [MatList, MatListItem, TranslatePipe],
})
export class DiscountTypeDetailsComponent implements OnInit, OnDestroy {
  discountTypeDetails$: Observable<any> = this.componentData.data$;
  discountTypeSubscription$: Subscription;
  discountTypeDetailsSubscription$: Subscription;
  discountType: string;
  discountBucketDetails: any;
  isLoading = false;

  constructor(
    private componentData: CmsComponentData<any>,
    private componentService: ComponentService,
    private discountsService: DiscountsService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.discountTypeSubscription$ = this.componentService.discountType$.subscribe((discountType) => {
      this.discountType = discountType;
      this.getDiscountBucketDetails(this.discountType);
      this.cdr.detectChanges();
    });
  }

  getDiscountBucketDetails(discountType: string) {
    this.isLoading = true;
    this.discountTypeDetailsSubscription$ = this.discountsService.shimanoDiscountBucketDetails$.subscribe(
      (bucketDetails) => {
        if (bucketDetails) {
          const discountBucketDetails = bucketDetails.filter(
            (bucketDetail: any) => bucketDetail && bucketDetail.code === discountType
          );
          this.discountBucketDetails = discountBucketDetails[0] && discountBucketDetails[0].details;
          this.isLoading = false;
        }
      }
    );
  }

  ngOnDestroy() {
    if (this.discountTypeSubscription$) {
      this.discountTypeSubscription$.unsubscribe();
    }
    if (this.discountTypeDetailsSubscription$) {
      this.discountTypeDetailsSubscription$.unsubscribe();
    }
  }
}
